import { render, staticRenderFns } from "./FreehandComment.vue?vue&type=template&id=13ab1853&scoped=true"
import script from "./FreehandComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreehandComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreehandComment.vue?vue&type=style&index=0&id=13ab1853&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab1853",
  null
  
)

export default component.exports